import React from 'react';
import {
    Routes,
    Route,
    Navigate,
} from 'react-router-dom';
// import withTracker from '../component/ga/withTracker';


import Home from '../pages/Plugify';
import Apple from '../pages/Apple';
import AlugueApple from '../pages/AlugueApple';
import AppleBM from '../pages/AppleABM'
import Erro404 from '../elements/error404';
import Obrigado from '../elements/obrigado';
import Contato from '../pages/Contato';
import PoliticaPrivacidade from '../blocks/about/PoliticaPrivacidade';

export default function MainRoutes() {
    return (
      
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/alugueapple" element={<AlugueApple />} />           
             <Route exact path="/apple" element={<Apple />} />
             <Route exact path="/contato" element={<Contato />} />
             <Route exact path="/appleabm" element={<AppleBM />} />
             <Route exact path="/PoliticaPrivacidade" element={<PoliticaPrivacidade />} />
             <Route path="/404" element={<Erro404 />} />
             <Route exact path="/sustentabilidade" element={<Navigate replace to="/" />}  />
             <Route path="/obrigado" element={<Obrigado />} />
             <Route path="*" element={<Erro404 />} />
             <Route render={() => <Navigate to="/" replace />}  />
        </Routes>
      
    )
};

